angular.module('app').config(vehiclesRouting);

function vehiclesRouting($routeProvider) {
  $routeProvider
    .when('/vehicles', {
      pageTitle: 'VEHICLES',
      template: '<vehicles-page></vehicles-page>',
      breadcrumb: {
        label: 'COMPANY_SETTINGS',
        parent: 'ng/company_settings',
      },
      accessPermission: 'index_vehicle_accountadmin',
      authReq: true,
    })
    .when('/vehicles/new', {
      pageTitle: 'ADD_VEHICLE',
      template: '<vehicle-page></vehicle-page>',
      breadcrumb: {
        label: 'VEHICLES',
        parent: 'vehicles',

        ajs: true,
      },
      accessPermission: 'create_vehicle_accountadmin',
      authReq: true,
    })
    .when('/vehicles/:id', {
      pageTitle: 'EDIT_VEHICLE',
      template: '<vehicle-page></vehicle-page>',
      breadcrumb: {
        label: 'VEHICLES',
        parent: 'vehicles',
        ajs: true,
      },
      accessPermission: 'show_vehicle_accountadmin',
      authReq: true,
    });
}

vehiclesRouting.$inject = ['$routeProvider'];
